import * as React from "react";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { useTheme } from "@mui/material/styles";
import { useHistory } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

function LocationsCard(props) {
  const theme = useTheme();
  const history = useHistory();
  const [hover, setHover] = useState(false);

  const onHover = () => {
    setHover(true);
  };

  const onLeave = () => {
    setHover(false);
  };

  return (
    <Box
      onMouseEnter={onHover}
      onMouseLeave={onLeave}
      sx={{
        height: "100%",
      }}
    >
      {hover &&
      <Box
        key={props.item.Displayed_Name}
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          padding: "3px",
          color: "white",
          borderRadius: "10px",
          textAlign: "center",
          cursor: 'pointer',
          filter: 'drop-shadow(0px 3px 8px rgba(12, 26, 75, 0.05))',
          ".MuiTypography-root": {
            color: "#fff",
          },
        }}>
        <Box sx={{
          background: "linear-gradient(180deg, rgba(206, 31, 157, 0.8) 0%, rgba(236, 98, 47, 0.8) 100%)",
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 2,
          borderRadius: "10px",
        }} />
        <Typography variant="subtitle1" gutterBottom component="div" sx={{
          fontWeight: 700,
          position: 'relative',
          zIndex: 3,
          textShadow: '0px 2px 3px rgba(0, 0, 0, 0.35)',
        }}>
          {props.item.Displayed_Name}
        </Typography>
        <Box sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          objectFit: 'cover',
          zIndex: 1,
          backgroundImage: `url(${props.item.Background})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          borderRadius: "10px",
        }} />
      </Box>
      }
      {!hover &&
      <Box
        key={props.item.Displayed_Name}
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          padding: "3px",
          color: "white",
          borderRadius: "10px",
          textAlign: "center",
          cursor: 'pinter',
          '.MuiTypography-root': {
            color: '#fff',
          },
          ...(APP.arrangement && APP.arrangement.selectedLocation === props.item.Name) && {
            background: "linear-gradient(90deg, #E94452 0%, #EC622F 100%)",
          },
          ...(APP.arrangement && APP.arrangement.selectedLocation !== props.item.Name) && {
            background: "#ccc",
            backgroundImage: `url(${props.item.Background})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          },
        }}>
        <Typography variant="subtitle1" gutterBottom component="div" sx={{fontWeight: 700}}>
          {props.item.Displayed_Name}
        </Typography>
        {(APP.arrangement && APP.arrangement.selectedLocation === props.item.Name) &&
        <Divider
          variant="middle"
          sx={{
            position: "absolute",
            marginBottom: "12px",
            left: "auto",
            right: "auto",
            bottom: "0",
            borderWidth: "1px",
            borderColor: "#fff",
            width: "70%",
          }} />
        }
      </Box>
      }
    </Box>
  );
}

export default function() {
  const theme = useTheme();
  const [, updateState] = React.useState({});
  const locations = APP.richMetadata.getAllLocations();
  SwiperCore.use([Navigation]);
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
  let targetOffset;

  useEffect(() => {
    targetOffset = $(".locations-slider").offset().top;
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScroll = (event) => {
    event.preventDefault();
    const position = window.scrollY;
    const threshold = position > targetOffset;
    if (threshold && window.innerWidth < 992) {
      $('.locations-slider').addClass('floating');
      $('#location-spacer').show();
    } else {
      $('.locations-slider').removeClass('floating');
      $('#location-spacer').hide();
    }
  };

  const applyLocationFilter = (locationName) => {
    APP.arrangement.selectedLocation = locationName;
    $("div[data-type=\"exhibitionListItem\"]").each((index, el) => {
      const locations = $(el).attr("data-locations");
      if (locations?.match(new RegExp(locationName, "i")) || locationName === "All") {
        $(el).show();
      } else {
        $(el).hide();
      }
    });
  };

  const handleLocationClick = (event, item) => {
    applyLocationFilter(item.Name);
    updateState({});
  };

  const checkForArrowVisibility = (swiper) => {
    const prevArrow = $('#location-slider-prev');
    const prevNext = $('#location-slider-next');

    if (swiper.activeIndex === 0) {
      prevArrow.hide()
      prevNext.show()
    } else if (swiper.isEnd) {
      prevArrow.show()
      prevNext.hide()
    } else {
      prevArrow.show()
      prevNext.show()
    }
  }

  return (
    <>
      <Box className={'locations-slider'} sx={{ flexGrow: 0, ".swiper-wrapper": { paddingBottom: "11px" }, position: 'relative' }}>
        <Swiper
          modules={[Navigation]}
          spaceBetween={11}
          slidesPerView={2.1}
          autoHeight={true}
          navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = navigationPrevRef.current;
            swiper.params.navigation.nextEl = navigationNextRef.current;
          }}
          onAfterInit={(swiper) => {
            checkForArrowVisibility(swiper);
          }}
          onSlideChange={(swiper) => {
            checkForArrowVisibility(swiper);
          }}
          breakpoints={
            {
              575: {
                slidesPerView: 3.1,
              },
              992: {
                slidesPerView: 4.1,
              },
              1200: {
                slidesPerView: 7.1,
              },
            }
          }
        >
          {locations.map((item) => (
            <SwiperSlide
              key={item.Name}
              onClick={(event) => handleLocationClick(event, item)}
            >
              <LocationsCard item={item} />
            </SwiperSlide>
          ))}
        </Swiper>
        <Box id={'location-slider-prev'} ref={navigationPrevRef} sx={{
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          left: '0.5%',
          top: '50%',
          transform: 'translate(10%, -50%)',
          zIndex: 100,
          backgroundColor: '#fff',
          padding: '3px',
          opacity: 0.9,
          borderRadius: '50%',
          height: '46px',
          boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.45)',
          '&:hover': {
            opacity: 1,
            cursor: 'pointer',
          },
        }}>
          <ChevronLeftIcon sx={{
            fill: '#000',
            fontSize: '2.5rem',
          }} />
        </Box>
        <Box id={'location-slider-next'} ref={navigationNextRef} sx={{
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          right: '0.5%',
          top: '50%',
          transform: 'translate(10%, -50%)',
          zIndex: 100,
          backgroundColor: '#fff',
          padding: '3px',
          opacity: 0.9,
          borderRadius: '50%',
          height: '46px',
          boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.45)',
          '&:hover': {
            opacity: 1,
            cursor: 'pointer',
          },
        }}>
          <ChevronRightIcon sx={{
            fill: '#000',
            fontSize: '2.5rem',
          }} />
        </Box>
      </Box>
      <Box id={'location-spacer'} sx={{height: '81px', display: 'none'}} />
    </>
  );
}
